import { createTRPCReact } from "@trpc/react-query";

import type { ApiRouter } from "@repos/fillout_payment-api";

export const trpc = createTRPCReact<ApiRouter>();
